export default "__VITE_ASSET__Bjbroehk__"